<template>
	<ul class="tree-menu">
		<li v-for="(item, key) in menulist" class="first-menu">
			<router-link :to="item.link"
			:class="{ 'icon-downTriangle': item.secondMenulist }" 
			@click="showSecondMenulist(item)" tag="a">{{ item.firstMenu }}<Ripple v-show="!item.secondMenulist"></Ripple></router-link>
			<ul class="second-menu-wrap">
				<li v-for="(item, key) in item.secondMenulist" class="second-menu">
					<router-link :to="item.link">{{ item.secondMenu }}<Ripple></Ripple></router-link>
				</li>
			</ul>
		</li>
	</ul>
</template>
<script>
	export default {
		name: 'treeMenu',
		props: {
			menulist: {
				type: Array,
			}
		},
		methods: {
			showSecondMenulist(item) {
				item.isShow = !item.isShow
			}
		},
		mounted: function() {
			$('.icon-downTriangle').click(function() {
				$(this).toggleClass('on');
			})
			$('a').click(function() {
				if (!$(this).hasClass('icon-downTriangle')) {
					$('.tree-menu').find('.on').removeClass('on')
					$(this).addClass('on')
				}
			})

		}
	}
</script>




// WEBPACK FOOTER //
// src/components/treeMenu/treeMenu.vue